var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isChatRoute)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShowChat),expression:"shouldShowChat"}],attrs:{"id":"tdWebchat"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }